import { API, setAuthToken } from '../../../config/API.js';
import { GET_HERO_SECTION, SET_LOADING_HERO_SECTION, SET_PAGINATION_HERO_SECTION } from '../constant.js';

export const getDataHero = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_HERO_SECTION,
      payload: true,
    });
    API.get(`admin/banner?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_HERO_SECTION,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_HERO_SECTION,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_HERO_SECTION,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_HERO_SECTION,
          payload: 0,
        });
      });
  };
};

export const addDataHero = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/banner/add", params);
};

export const getDetailDataHero = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/banner/${code}`);
};

export const updDataHero = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/banner/edit", params);
};

export const delDataHero = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/banner/delete/" + code);
};
